import { render, staticRenderFns } from "./PrivadosTable.vue?vue&type=template&id=197eedf0"
import script from "./PrivadosTable.vue?vue&type=script&lang=js"
export * from "./PrivadosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports